import React from 'react'
import PropTypes from 'prop-types'
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import * as notificationActionCreators from '../../../redux/notifications'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

export class RemoveUserTrainingModal extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    isSending: PropTypes.bool,
  }

  render() {
    return (
      <React.Fragment>
        <ModalHeader toggle={this.props.closeModal}>
          Remove User Training Access
        </ModalHeader>
        <ModalBody>
          <p>This action will remove Training Access.</p>
          <p className="font-weight-bold">Would you like to continue?</p>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-fixed-width"
            color="link"
            onClick={this.props.closeModal}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            className="btn-fixed-width"
            color="primary"
            disabled={this.props.isSending}
            onClick={this.cancelUserAccess}
            size="sm"
          >
            {this.props.isSending && <i className="fas fa-spinner fa-spin" />}
            {!this.props.isSending && 'Confirm'}
          </Button>
        </ModalFooter>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({}) => ({})

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      ...licenseActionCreators,
      ...notificationActionCreators,
    },
    dispatch,
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemoveUserTrainingModal)



// WEBPACK FOOTER //
// ./src/containers/css-admin/users/RemoveUserTrainingModal.js